import type {ReactElement} from 'react';

export const SessionLoading = (): ReactElement => (
  <div aria-label="Checking your Reaktor session" className="min-h-screen bg-reaktor-page" role="status" />
);
